import { useContext } from "react";
import { Box, Chip, Typography } from "@mui/material";
import { Office365GroupContext } from "../../context/Office365GroupContext";
import { useOffice365GroupOwnership } from "./useOffice365GroupOwnership";

const WSU_RED = "#A60F2D";

const chipSx = {
    backgroundColor: "#fdf0f2",
    border: `1px solid ${WSU_RED}`,
    color: WSU_RED,
    fontWeight: 500,
    fontSize: "0.75rem",
    height: "auto",
    maxWidth: "100%",
    "& .MuiChip-label": {
        display: "block",
        whiteSpace: "normal",
        overflowWrap: "anywhere",
        wordBreak: "break-word",
        py: 0.5,
    },
};

const renderOwners = (owners) =>
    owners?.length > 0 ? (
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.75 }}>
            {owners.map((owner) => (
                <Chip
                    key={owner.userPrincipalName}
                    label={owner.userPrincipalName}
                    size="small"
                    sx={chipSx}
                />
            ))}
        </Box>
    ) : (
        <Typography variant="body2" color="text.disabled" fontStyle="italic">No owners found</Typography>
    );

// Returns a single "Owners" tile, sized by the combined length of every
// owner's UPN so a large ownership list gets a wider tile.
export const useOffice365GroupOwnershipSections = () => {
    const { isLoaded, error } = useOffice365GroupOwnership();
    const { groupModule } = useContext(Office365GroupContext);

    if (!isLoaded || error) {
        return { isLoaded, error, tiles: [] };
    }

    const owners = groupModule.owners || [];
    const length = owners.map((o) => o.userPrincipalName).join(", ").length;

    const tiles = [{
        key: "Owners",
        heading: "Owners",
        rows: [{ key: "owners", label: "Owners", content: renderOwners(owners), length }],
        maxLength: length,
    }];

    return { isLoaded, error, tiles };
};
